(function () {
  const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function syncCurrency() {
    // R1: используем ТОТ ЖЕ цикл, что отрабатывает после подмены секций
    // корзины — с повторами до 800 мс и проверкой сходимости. Одиночный
    // refreshConversion() успевал отработать раньше Nova, и на витрине
    // оставалась цена прежнего варианта.
    if (typeof window.amoreRestartConversion === 'function') {
      window.amoreRestartConversion();
      return;
    }
    if (window.baCurr && typeof window.baCurr.refreshConversion === 'function') {
      window.baCurr.refreshConversion();
    }
    if (typeof window.amoreUpdateCurrencyCodes === 'function') {
      window.amoreUpdateCurrencyCodes();
    }
  }

  class AmoreProduct extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variants = this.readVariants();
      this.form = this.querySelector('product-form form');
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.submit = this.querySelector('[data-amore-pdp-submit]');
      this.submitLabel = this.querySelector('[data-amore-pdp-submit-label]');
      this.stick = this.querySelector('[data-amore-pdp-stick]');
      this.stickLabel = this.querySelector('[data-amore-pdp-stick-label]');
      this.stickSubmit = this.querySelector('[data-amore-pdp-stick-submit]');
      this.price = this.querySelector('[data-amore-pdp-price-display]');
      this.idr = this.querySelector('[data-amore-pdp-idr]');
      // Сумма, которую сервер уже отрисовал: пока она не изменилась,
      // подменять узел не нужно (см. renderPrice).
      const initialVariant = (this.variants || []).find(
        (candidate) => String(candidate.id) === String(this.dataset.selectedVariantId)
      );
      if (initialVariant) this.dataset.amorePriceCents = String(initialVariant.price);
      this.status = this.querySelector('[data-amore-pdp-status]');
      this.drawer = this.querySelector('[data-amore-pdp-details]');
      this.lastDrawerTrigger = null;
      this.unit = 'cm';

      this.bindSizes();
      this.bindGallery();
      this.bindDetails();
      this.bindMeasurements();
      this.bindStickyButton();
      this.bindStyleWith();
      this.bindStickyColumn();
      this.bindDiagramResize();

      const selected = this.variantById(this.dataset.selectedVariantId);
      if (selected) this.applyVariant(selected, false);
      else this.updateMeasurementState('');
    }

    readVariants() {
      try {
        return JSON.parse(this.querySelector('[data-amore-pdp-variants]')?.textContent || '[]');
      } catch (_error) {
        return [];
      }
    }

    variantById(id) {
      return this.variants.find((variant) => String(variant.id) === String(id)) || null;
    }

    bindSizes() {
      this.querySelectorAll('[name^="amore-size-"]').forEach((input) => {
        input.addEventListener('change', () => {
          const variant = this.variantById(input.value);
          if (variant) this.applyVariant(variant, true);
        });
      });
    }

    /* R1: денежный узел ПОДМЕНЯЕТСЯ свежим элементом, когда сумма фактически
       изменилась. Причина: Nova раз в секунду восстанавливает узлы из кэша,
       снятого при первой загрузке, и возвращала цену базового варианта поверх
       верно сконвертированной цены Tailored (замер: верное значение на 7 мс,
       откат на 1002 мс). Перезапись текста этого не лечит — узел остаётся тем
       же, и в кэше он есть. Новый элемент в старом кэше не найдётся, как бы
       тот ни был устроен: хоть по ссылке на узел, хоть массивом снимков.
       Это тот же путь, которым уже идёт корзина: Dawn заменяет секции Ajax-ом,
       и наценка Tailored там отражается верно.
       Подменяем ТОЛЬКО при смене суммы: у Basque Skirt все размерные варианты
       стоят одинаково, и на каждый клик по размеру плодить узлы незачем. */
    renderPrice(variant) {
      const nextCents = String(variant.price);
      if (this.dataset.amorePriceCents === nextCents) {
        // Сумма та же — узел не трогаем, чтобы не плодить элементы.
        return;
      }

      const fresh = document.createElement('span');
      // Переносим ровно нашу разметку: класс, по которому узел находит Nova,
      // и атрибут, по которому его находим мы. Метку `bacurr-money` НЕ
      // переносим — для Nova это новый, ещё не сконвертированный узел.
      fresh.className = 'money';
      fresh.setAttribute('data-amore-pdp-price-display', '');
      fresh.textContent = variant.priceFormatted;

      this.price.replaceWith(fresh);
      this.price = fresh;
      this.dataset.amorePriceCents = nextCents;
    }

    applyVariant(variant, updateUrl) {
      this.dataset.selectedVariantId = variant.id;
      this.querySelectorAll('[name^="amore-size-"]').forEach((input) => {
        input.checked = String(input.value) === String(variant.id);
      });

      if (this.variantInput) {
        this.variantInput.value = variant.id;
        this.variantInput.disabled = !variant.available;
      }
      if (this.submit) this.submit.disabled = !variant.available;
      if (this.submitLabel) this.submitLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (this.stickSubmit) {
        this.stickSubmit.disabled = !variant.available;
        this.stickSubmit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (this.stickLabel) this.stickLabel.textContent = variant.size;
      if (this.price) this.renderPrice(variant);
      if (this.idr) this.idr.textContent = variant.idrLine;

      const tailored = variant.size === 'Tailored';
      const buttonNote = this.querySelector('[data-amore-pdp-tailored-note]');
      const returnPromise = this.querySelector('[data-amore-pdp-promise-return]');
      if (buttonNote) buttonNote.hidden = !tailored;
      if (returnPromise) returnPromise.textContent = tailored ? 'Altered or remade if the fit is off' : '14-day returns';

      this.updateMeasurementState(variant.size);
      syncCurrency();
      // PDP-06 (12.09.2026): цена/строка рупий у соседнего варианта может
      // быть длиннее и перенестись на вторую строку — это меняет высоту
      // липкого верхнего этажа, от которой считают свой top все этажи
      // ниже (PDP-06H: описание, аккордеоны, «Style with»). Дешёвая
      // перестраховка на каждую смену размера.
      this.recomputeStickyColumn?.();

      if (updateUrl) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      if (this.status) this.status.textContent = `Size ${variant.size} selected. Price ${variant.priceFormatted}.`;
    }

    bindGallery() {
      const gallery = this.querySelector('[data-amore-pdp-gallery]');
      const track = this.querySelector('[data-amore-pdp-gallery-track]');
      const frames = Array.from(this.querySelectorAll('[data-amore-pdp-frame]'));
      const segments = Array.from(this.querySelectorAll('[data-amore-pdp-gallery-segments] i'));
      const zoom = this.querySelector('[data-amore-pdp-zoom]');
      const zoomScroll = this.querySelector('[data-amore-pdp-zoom-scroll]');
      const zoomFrames = Array.from(this.querySelectorAll('[data-amore-pdp-zoom-frame]'));
      const zoomThumbs = Array.from(this.querySelectorAll('[data-amore-pdp-zoom-thumb]'));
      if (!gallery || !track) return;

      const setCurrent = (index) => {
        frames.forEach((frame, frameIndex) => frame.classList.toggle('is-current', frameIndex === index));
        segments.forEach((segment, segmentIndex) => segment.classList.toggle('is-current', segmentIndex === index));
        zoomThumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-current', thumbIndex === index));
      };

      track.addEventListener('scroll', () => {
        if (window.matchMedia('(min-width: 900px)').matches || !track.clientWidth) return;
        setCurrent(Math.max(0, Math.min(frames.length - 1, Math.round(track.scrollLeft / track.clientWidth))));
      }, { passive: true });

      const openZoom = (index) => {
        if (!zoom || typeof zoom.showModal !== 'function') return;
        zoom.showModal();
        document.body.classList.add('amore-pdp-layer-open');
        requestAnimationFrame(() => {
          zoomFrames[index]?.scrollIntoView({ block: 'start' });
          setCurrent(index);
        });
      };
      const closeZoom = () => {
        if (!zoom?.open) return;
        zoom.close();
        document.body.classList.remove('amore-pdp-layer-open');
      };

      frames.forEach((frame, index) => frame.addEventListener('click', () => openZoom(index)));
      zoomFrames.forEach((frame) => frame.addEventListener('click', closeZoom));
      zoomThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
        zoomFrames[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setCurrent(index);
      }));
      this.querySelector('[data-amore-pdp-zoom-close]')?.addEventListener('click', closeZoom);
      zoom?.addEventListener('cancel', (event) => {
        event.preventDefault();
        closeZoom();
      });
      zoomScroll?.addEventListener('scroll', () => {
        if (!zoomScroll.clientHeight) return;
        setCurrent(Math.max(0, Math.min(zoomFrames.length - 1, Math.round(zoomScroll.scrollTop / zoomScroll.clientHeight))));
      }, { passive: true });
    }

    bindStickyButton() {
      if (!this.stick || !this.submit || typeof IntersectionObserver !== 'function') return;
      // FRAME-09 п.4: `hidden = false` раньше шло безусловно и синхронно, а
      // единственный механизм, который должен был не дать полосе показаться
      // при видимой основной кнопке — асинхронный колбэк IntersectionObserver,
      // без какой-либо синхронной начальной проверки. Между показом и первым
      // срабатыванием наблюдателя есть зазор, в течение которого действует
      // CSS-состояние "по умолчанию видимо" (FRAME-08 recon вопрос 4).
      // Синхронная проверка перед первым показом закрывает этот зазор: если
      // основная кнопка уже в кадре — полоса стартует скрытой. Наблюдатель
      // ниже не тронут.
      const submitRect = this.submit.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      const submitInView = submitRect.bottom > 0 && submitRect.top < viewportHeight &&
        submitRect.right > 0 && submitRect.left < viewportWidth;
      this.stick.classList.toggle('is-hidden', submitInView);
      this.stick.hidden = false;
      // PDP-FIX-01 п.2: раньше был один порог (`entries.some(isIntersecting)`),
      // из-за чего полоса дребезжала на границе кнопки. Теперь два разных
      // условия с разными порогами, каждое отвечает только за одно
      // направление: показ — когда кнопка покупки ушла вверх экрана
      // (`!isIntersecting && boundingClientRect.top < rootBounds.top`); скрытие —
      // когда кнопка снова видна больше чем на 55% (`intersectionRatio > 0.55`).
      // Между ними намеренно есть зазор (не сворачивать в одно выражение).
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const scrolledPastTop = !entry.isIntersecting &&
            entry.rootBounds && entry.boundingClientRect.top < entry.rootBounds.top;
          if (scrolledPastTop) {
            this.stick.classList.remove('is-hidden');
          } else if (entry.intersectionRatio > 0.55) {
            this.stick.classList.add('is-hidden');
          }
        });
      }, { threshold: [0, 0.55] });
      observer.observe(this.submit);
    }

    bindStyleWith() {
      // PDP-06 (12.09.2026): раньше здесь же жила механика «явления по
      // скроллу» (progress от позиции пятого кадра галереи, --amore-style-
      // progress, requestAnimationFrame на каждый scroll/resize) — она и
      // была причиной symptom «фото Style with не помещаются»: блок был
      // обычным содержимым внутри единого sticky-блока `.amore-pdp__buy`,
      // ограниченного высотой окна, и обрезался по max-height 360px вместо
      // того, чтобы физически проехать по колонке. Заменена на настоящий
      // sticky-этаж — bindStickyColumn() ниже. Здесь остаётся только смена
      // подписи под курсором/фокусом, к раскладке отношения не имеющая.
      const styleWith = this.querySelector('[data-amore-style-with]');
      if (!styleWith) return;
      const label = styleWith.querySelector('[data-amore-style-label]');
      const price = styleWith.querySelector('[data-amore-style-label-price]');
      const cards = Array.from(styleWith.querySelectorAll('[data-amore-style-card]'));

      const resetLabel = () => {
        if (label) label.textContent = 'Style with';
        if (price) price.textContent = '';
      };
      cards.forEach((card) => {
        const showLabel = () => {
          if (label) label.textContent = card.dataset.amoreStyleTitle || '';
          if (price) price.textContent = card.querySelector('[data-amore-style-price]')?.textContent.trim() || '';
        };
        card.addEventListener('mouseenter', showLabel);
        card.addEventListener('mouseleave', resetLabel);
        card.addEventListener('focus', showLabel);
        card.addEventListener('blur', resetLabel);
      });
    }

    // PDP-06 (12.09.2026, возврат 12.09.2026), PDP-06E (14.09.2026),
    // PDP-06F (14.09.2026), PDP-06H (14.09.2026): четыре липких этажа
    // колонки покупки (эталон Toteme) — верхний блок (имя/цена/размеры/
    // кнопка/предзаказ), затем описание, затем аккордеоны, затем
    // «Style with». Смещения не зашиты в CSS, потому что все зависят от
    // фактического контента.
    //
    // GAP_TRUTH (24) и описание как второй этаж — PDP-06H. Владелец принял
    // (c) по стоп-условию: заморозка PDP-06G «кнопка → первая ссылка 43»
    // снята явно, новое число не назначено. Поэтому GAP_TRUTH просто берёт
    // прежний зазор кнопки (24px, `.amore-pdp__truth { margin: 24px 0 0 }`
    // в базовой секции файла — CSS-правило НЕ ТРОГАЛОСЬ по прямому
    // указанию наряда), а GAP_ACCORDIONS (43) ниже остаётся тем же числом,
    // но естественно становится зазором «описание → первая ссылка» вместо
    // «кнопка → первая ссылка» — наряд запретил назначать новое число, это
    // не новое число, это то же самое на новом месте. Товары с пустым
    // `amore.product_truth` не рендерят `.amore-pdp__truth` вовсе (см.
    // amore-pdp.liquid, `{%- if amore_truth != blank -%}`) — recompute()
    // ниже читает `truth` как возможный `null` и в этом случае аккордеоны
    // возвращаются к прежней формуле (без промежуточного этажа), без
    // отдельного if/else — просто GAP_TRUTH + высота этажа обнуляются.
    //
    // HEADER_OFFSET (72) — шапка, тот же литерал, что `top: 72px` у
    // `.amore-pdp__buy-top` в amore-pdp.css (см. комментарий там же про
    // `--amore-header-height`, зону "рама" и почему не читаем переменную
    // напрямую) — здесь он снова нужен явно: первый этаж сам сдвинут
    // `top`-смещением (не `padding-top` — тот вариант ломал позицию имени
    // на нулевой прокрутке, см. otchety/PDP-06/otchet-vozvrat.md), поэтому
    // его getBoundingClientRect не включает эти 72px, и второй этаж должен
    // добавить их сам.
    //
    // GAP_ACCORDIONS (43): воздух низ кнопки → текст первой строки ссылок.
    // Наряд PDP-06F не менял.
    //
    // GAP_STYLE_BOTTOM (25) и парковка «высота окна − собственная высота −
    // 25px» — СНЯТЫ нарядом PDP-06H (14.09.2026). Symptom наряда: расстояние
    // «низ последней ссылки → верх „Style with“» по тексту 236px против
    // эталонных (toteme.com, 14.09) 73 — парковка от окна была тому не
    // причиной, а лишь тем, из-за чего расхождение не было замечено раньше.
    // GAP_STYLE_TOP (73) ниже считает top от ФАКТИЧЕСКОЙ позиции второго
    // этажа (аккордеоны), тем же методом «по тексту» (textEdges), каким
    // наряд измеряет это на приёмке — не от окна. minTopForFlush/buyInner
    // (пол на случай короткой галереи) снят вместе с парковкой: он был
    // нужен только формуле «от окна», чтобы не недоезжать при нехватке
    // scroll-дистанции — у формулы «от предыдущего этажа» этого класса
    // проблемы нет по построению (аккордеоны считаются тем же способом и
    // без такого пола). Остаток между низом блока и низом галереи по-
    // прежнему ограничен растянутым `.amore-pdp__buy-inner` (см. ниже), но
    // теперь не измеряется и не задаётся числом (наряд PDP-06H, п.3).
    //
    // «Доезжает до низа галереи без зазора» по-прежнему не от top, а от
    // того, что родитель (amore-pdp.css, `.amore-pdp__hero`/`-buy-inner`)
    // растянут на высоту галереи — sticky физически не уводит элемент
    // дальше края своего контейнера.
    //
    // PDP-06F: показ/скрытие по классу (`.is-visible`, PDP-06E) снят
    // целиком — условие «низ описания под верхним этажом» на практике
    // срабатывало не всегда (замер владельца 14.09: love-bustier ни разу,
    // baska то появлялся, то нет на одном и том же окне — гонка между
    // первым 'scroll' и layout после загрузки шрифтов/картинок). Вместо
    // видимости — расстояние: блок всегда в DOM и всегда visible/opacity:1
    // (amore-pdp.css), просто стоит НИЖЕ первого экрана. MARGIN_BELOW_FOLD
    // (40) — тот же зазор, что раньше держала CSS-переменная `margin-top`
    // (наряд PDP-06D/05, «было 34, базовое правило»), теперь его держит
    // JS: верх блока на scrollY=0 обязан быть на «высота окна + 40»
    // независимо от накопленной высоты контента ДО него (имя/цена/размеры/
    // кнопка/предзаказ/описание/ссылки — разного роста на разных товарах),
    // поэтому натуральную (несклеенную) позицию блока каждый раз считаем
    // и подгоняем через margin-top, а не полагаемся на то, что она и так
    // окажется нужной.
    //
    // Пересчёт — на resize (PDP-06F, п.4: раньше top парковки на «Style
    // with» считался один раз при загрузке и не переживал смену высоты
    // окна без перезагрузки; margin-top для «ниже сгиба» — по той же
    // причине, а не только top) и на смену варианта (bindSizes →
    // applyVariant, высота первого этажа/текста может измениться).
    bindStickyColumn() {
      // PDP-09 (15.09.2026): раньше здесь был один узел `[data-amore-pdp-buy-top]`
      // — имя/цена/размеры/кнопка одним блоком. Теперь это два раздельных
      // блока в DOM (имя+цена и размеры+кнопка), нужных для мобильного
      // CSS `order` (см. amore-pdp.liquid, комментарий PDP-09) — на
      // десктопе они по-прежнему стоят вплотную, без зазора между ними, и
      // высота первого «липкого этажа» — их СУММАРНАЯ высота, а не высота
      // одного элемента. `topEnd.bottom - topStart.top` даёт ту же цифру,
      // что раньше давала высота единого buy-top (два блока стоят впритык).
      const topStart = this.querySelector('[data-amore-pdp-buy-top-name]');
      const topEnd = this.querySelector('[data-amore-pdp-buy-top-purchase]');
      if (!topStart || !topEnd || typeof window.matchMedia !== 'function') return;
      const truth = this.querySelector('[data-amore-pdp-truth]');
      const accordions = this.querySelector('.amore-pdp__detail-links');
      const styleWith = this.querySelector('[data-amore-style-with]');
      if (!truth && !accordions && !styleWith) return;

      // PDP-06I, третий заход (15.09.2026, вечер): владелец прислал живой
      // скриншот Safari (реальное окно, ~1470×?) — фотографии галереи
      // кончаются заметно выше подвала, между ними и подвалом пустой
      // белый разрыв (тем же прыжком «Style with» вниз колонки покупки,
      // без наезда — второй заход это закрыл верно). CSS держит высоту
      // колонки покупки через `align-items: stretch` на `.amore-pdp__hero`
      // (amore-pdp.css) — «растягивает на высоту строки, галерею не
      // трогает, она уже самая высокая колонка» (комментарий там же,
      // 12.09.2026), то есть высота ряда неявно = max(высота галереи,
      // натуральная высота колонки покупки). Симптом означало бы обратное:
      // натуральная высота колонки покупки (со сдвигом «Style with» вниз
      // на MARGIN_BELOW_FOLD = высота окна + 40) в какой-то момент обошла
      // высоту галереи, и grid растянул ГАЛЕРЕЮ до этой большей высоты —
      // добавочные пиксели у нее физически пустые, фотографиям взяться
      // неоткуда.
      //
      // Не воспроизвелось в Browser pane (Chromium) ни на одной из
      // проверенных геометрий — 1440×900, 1728×1000, 1470×900, и отдельно
      // 1470×1300 (человеческий рост окна нарочно взят с запасом): во
      // всех четырёх высота галереи после `scrollTo(maxY)` совпадала с
      // верхом подвала день в день, разрыва 0px. Проверялось замером
      // `getBoundingClientRect()` галереи и подвала, не на глаз. Значит
      // дело не в самой формуле высоты — она зависит только от ширины/
      // высоты окна и количества кадров, а от них разрыв в Chromium не
      // родился ни разу. Остаётся разница в том, как именно Safari
      // (WebKit) considers intrinsic-высоту grid-ряда с `align-items:
      // stretch`, когда внутри колонки несколько независимых
      // `position: sticky` элементов на разных `top` — это ГИПОТЕЗА, не
      // подтверждённая: включить Safari remote automation агенту нельзя
      // (см. OTKRYTOE.md, «Ждёт владельца»), проверить фактическое
      // поведение WebKit агент не может.
      //
      // Правка не чинит гипотетический баг WebKit напрямую (нечем
      // проверить, что именно чинишь), а убирает саму возможность
      // расхождения: высота `.amore-pdp__buy` в каждом recompute()
      // ставится ЯВНО, пикселем, равным фактической высоте галереи
      // (`gallery.getBoundingClientRect().height`) — тем же способом,
      // каким это уже меряется здесь для всего остального (не полагаясь
      // на браузер). `align-items: stretch` в CSS не снят — минимальная
      // подстраховка, если JS почему-то не отработает раньше первой
      // отрисовки.
      const buyColumn = this.querySelector('.amore-pdp__buy');
      const gallery = this.querySelector('.amore-pdp-gallery');

      const HEADER_OFFSET = 72;
      const GAP_TRUTH = 24;
      const GAP_ACCORDIONS = 43;
      // PDP-06I, ШЕСТОЙ ЗАХОД (15.09.2026, ночь): механика «Style with»
      // переписана целиком по образцу toteme.com (владелец прислал прямую
      // ссылку на живой товар и потребовал скопировать именно этот узел —
      // см. наряд/переписку 15.09 ночь). Разобрано чтением их CSS
      // (matched-rules, не догадкой): `.prd-StyleWith` — `position: sticky;
      // inset-block-start: calc(100vh - var(--Style_Height) - var(--s24))`
      // — блок сам прибивается к НИЗУ ОКНА (собственная высота + 24px
      // отступа от низа), НЕ к позиции аккордеонов над ним. А аккордеоны
      // (`.prd-Detail_Tabs`) держат `margin-block-end: calc(var(--Style_
      // Height) + 2rem)` — то есть резервируют место под собой в потоке
      // документа заранее, а не полагаются на JS-коррекцию на scroll.
      //
      // Это и есть причина, по которой у НАС «Style with» мог наехать на
      // аккордеоны или на подвал (заходы 3–5 этой же ночи): мы держали
      // сначала общий контейнер `.amore-pdp__buy` растянутым на высоту
      // галереи (это верно, у Toteme то же самое — align-items:stretch на
      // строке грида), но НИЧЕГО не резервировало место конкретно под
      // «Style with» в потоке — и когда родная sticky-containment упиралась
      // в низ контейнера раньше времени, чинить это приходилось на лету,
      // через `transform` на каждый scroll (`tailGuard()`, теперь снят).
      // У Toteme чинить нечего: резерв стоит заранее, containment никогда
      // не оказывается в тесноте.
      //
      // GAP_STYLE_BOTTOM (24) — тот же зазор, что у Toteme (`--s24`,
      // тот же порядок величины, что наш GAP_TRUTH=24 у другого этажа).
      // GAP_STYLE_RESERVE (73) — прежний GAP_STYLE_TOP, значение не
      // менялось, только роль: раньше это был зазор «верх Style with от
      // аккордеонов» (top считался ОТ аккордеонов), теперь это буфер
      // резерва потока НИЖЕ аккордеонов (margin-bottom), тем же числом —
      // прямого замера под НОВУЮ роль числа не делалось, это перенос
      // старого принятого зазора на новую формулу, не досочинённое.
      const GAP_STYLE_BOTTOM = 24;
      const GAP_STYLE_RESERVE = 73;

      const recompute = () => {
        if (!window.matchMedia('(min-width: 900px)').matches) {
          topEnd.style.removeProperty('top');
          if (truth) truth.style.removeProperty('top');
          if (accordions) {
            accordions.style.removeProperty('top');
            accordions.style.removeProperty('margin-bottom');
          }
          if (styleWith) {
            styleWith.style.removeProperty('top');
          }
          if (buyColumn) buyColumn.style.removeProperty('min-height');
          return;
        }
        // PDP-06I, третий заход: пикселем, не через CSS-stretch — см.
        // комментарий у объявления `buyColumn`/`gallery` выше.
        if (buyColumn && gallery) {
          buyColumn.style.minHeight = `${gallery.getBoundingClientRect().height}px`;
        }
        // PDP-09: `-purchase` — второй кусок того же (раньше единого)
        // первого липкого этажа, стоит вплотную под `-name` без зазора —
        // top не CSS-литерал (не знает высоты имени/цены заранее, разная
        // у разных товаров), а HEADER_OFFSET + фактическая высота `-name`.
        const topEndTop = HEADER_OFFSET + topStart.getBoundingClientRect().height;
        topEnd.style.top = `${topEndTop}px`;
        // PDP-06H: высота промежуточного этажа (GAP_TRUTH + собственная
        // высота описания) — 0, когда `truth` нет в DOM (пустое метаполе),
        // так аккордеоны сами возвращаются к формуле без этого этажа.
        const topHeight = topEnd.getBoundingClientRect().bottom - topStart.getBoundingClientRect().top;
        let truthFloorHeight = 0;
        if (truth) {
          const truthTop = HEADER_OFFSET + topHeight + GAP_TRUTH;
          truth.style.top = `${truthTop}px`;
          truthFloorHeight = GAP_TRUTH + truth.getBoundingClientRect().height;
        }
        if (accordions) {
          const accordionsTop = HEADER_OFFSET + topHeight + truthFloorHeight + GAP_ACCORDIONS;
          accordions.style.top = `${accordionsTop}px`;
        }
        if (styleWith) {
          // ШЕСТОЙ ЗАХОД: top считается от НИЗА ОКНА (Toteme-формула), не
          // от позиции аккордеонов. Высота блока не зависит от того, стоит
          // ли на нём `position:sticky` или какой у него `top` — снимать
          // её можно прямо так, без временного `position:static`, в
          // отличие от прежней margin-top-механики выше (снята целиком).
          const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          const styleWithHeight = styleWith.getBoundingClientRect().height;
          styleWith.style.top = `${viewportHeight - styleWithHeight - GAP_STYLE_BOTTOM}px`;

          // Резерв места в потоке НИЖЕ аккордеонов — сам механизм, ради
          // которого затевался этот заход. Без него natural sticky
          // containment аккордеонов и «Style with» может упереться в низ
          // контейнера раньше, чем оба блока займут свои конечные позиции,
          // и тогда либо аккордеоны, либо «Style with» отклеятся раньше
          // срока. Резерв гарантирует контейнеру достаточно высоты заранее,
          // а не чинит нехватку на лету.
          if (accordions) {
            accordions.style.marginBottom = `${styleWithHeight + GAP_STYLE_RESERVE}px`;
          }
        }
      };

      // PDP-06I, шестой заход (15.09.2026, ночь): весь блок выше (tailGuard,
      // transform: translateY() на scroll) — удалён целиком, по прямому
      // указанию владельца скопировать механизм с toteme.com/en-ap/products/
      // low-waist-slim-trousers-black-1. Причина удаления — не косметика:
      // transform НАМЕРЕННО не участвует в расчёте sticky-контейнмента
      // (см. был комментарий выше, ныне удалён вместе с кодом) — то есть
      // весь механизм был построен на побеге от единственной защиты,
      // которая физически не даёт двум sticky-соседям наехать друг на
      // друга. Каждый «заход» (со второго по пятый) чинил новый частный
      // случай той же самой утечки, а не саму утечку.
      //
      // Measured на живой странице Toteme (чтение `document.styleSheets`,
      // не догадка): у них ДВА этажа sticky в одном контейнере, как и у
      // нас (аналог наших «аккордеонов» и «Style with»), и ни один не
      // использует transform. Вместо этого — `margin-block-end` на каждом
      // этаже, размером ровно с то, что должно поместиться под ним
      // (Style-блок + отступ) — резервирует место В ПОТОКЕ документа
      // заранее, а не чинит нехватку на лету скроллом. Последний этаж
      // («Style with» у них, тот же по роли элемент, что у нас) закреплён
      // формулой `top: calc(100vh - var(--Style_Height) - var(--s24))` —
      // считает свою позицию от низа ЭКРАНА, не от родительского sticky-
      // контейнмента, поэтому естественным образом скрыт под первым
      // экраном при загрузке и сам «подъезжает» снизу при скролле, без
      // единой строчки на 'scroll'.
      //
      // Перенесено сюда: `accordions.style.marginBottom` (резерв места,
      // см. recompute() выше) + `styleWith.style.top` по вьюпортной
      // формуле (тоже recompute(), см. выше) — оба уже посчитаны один раз
      // на resize/fonts.ready тем же способом, каким этот файл и раньше
      // считал `top` (JS once, не на каждый кадр скролла) — это НЕ
      // менялось, это уже было верно и совпадает с тем, как Toteme
      // хранит свои `--Top`/`--Style_Height` в CSS-переменных.

      // PDP-06G (14.09.2026): было throttle через requestAnimationFrame —
      // снято. Замер владельца воспроизвёлся буквально: меняешь высоту
      // окна без перезагрузки, атрибут `top` остаётся прежним, блок уходит
      // за нижний край на разницу высот. Причина — rAF не гарантированно
      // выполняется вовремя (а в фоновой/неактивной вкладке не выполняется
      // вовсе, пока вкладка не станет активной), и застрявший `ticking`
      // ждать было нечего — сам колбэк просто не запускался. `resize` не
      // настолько частое событие (не drag внутри canvas на каждый пиксель),
      // чтобы экономить на нём кадр отрисовки; debounce на setTimeout — тот
      // же эффект «не считать на каждое микрособытие», но без зависимости
      // от того, рисует ли браузер сейчас эту вкладку.
      let debounceTimer = null;
      const requestRecompute = () => {
        if (debounceTimer) window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => {
          debounceTimer = null;
          recompute();
        }, 50);
      };

      window.addEventListener('resize', requestRecompute);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(requestRecompute);
      }
      // PDP-06F: конвертация валют (syncCurrency → amoreRestartConversion,
      // см. её же комментарий выше в файле) сама себя описывает как цикл
      // «с повторами до 800 мс» — она меняет текст строки рупий уже ПОСЛЕ
      // того, как этот recompute() отработал (и на resize/fonts.ready
      // тоже), без события, на которое можно было бы подписаться отсюда.
      // Если высота первого этажа от этого меняется, margin-top блока
      // «Style with» и top аккордеонов успевают устареть на те же 800 мс.
      // Разовый отложенный пересчёт после задокументированного окна
      // подчищает это, не трогая саму конвертацию (чужая зона).
      window.setTimeout(requestRecompute, 900);
      this.recomputeStickyColumn = requestRecompute;
      recompute();
    }

    bindDetails() {
      if (!this.drawer) return;
      this.querySelectorAll('[data-amore-pdp-details-open]').forEach((button) => {
        button.addEventListener('click', () => {
          this.lastDrawerTrigger = button;
          this.requestOpenDetails(button.dataset.amorePdpDetailsOpen);
        });
      });
      this.bindDetailsTabs();
      this.bindDetailsDrag();
      this.querySelector('[data-amore-pdp-details-close]')?.addEventListener('click', () => this.closeDetails());
      // Клик мимо шторки ловит общая вуаль: она и закрывает (amore-frame.js).
      this.drawer.addEventListener('keydown', (event) => this.trapDrawerFocus(event));
    }

    // PDP-09/мобильный интерактив (15.09.2026): по разбору владельца
    // (макет maket-pdp-mobile-interaktiv-2026-09-15, подтверждено кликами
    // на toteme.com) — тап по строке шторки на мобильной ширине, когда
    // страница уже прокручена вниз, сначала плавно возвращает её к верху
    // (снова видно фото), и только потом открывается лист. Это НАШ приём,
    // не заимствованный у Toteme (владелец прямо это указал в макете) —
    // сделано, потому что владелец хочет фото над листом всегда. Только
    // мобильная ветка (≤899px): на десктопе колонка покупки уже липкая у
    // верха экрана, скроллить нечего, и десктоп этот заход прямо не
    // трогает («мы правки сейчас вносим только на телефоне, комп не
    // трогаем», 15.09). `scrollY <= 4` — тот же порог, что в макете
    // (`scr.scrollTop > 4`), просто источник скролла там был свой div
    // (device-фрейм макета), здесь — окно страницы.
    requestOpenDetails(name) {
      const isMobile = typeof window.matchMedia === 'function' &&
        window.matchMedia('(max-width: 899px)').matches;
      if (!isMobile || window.scrollY <= 4) {
        this.openDetails(name);
        return;
      }
      const onSettled = () => this.openDetails(name);
      if ('onscrollend' in window) {
        window.addEventListener('scrollend', onSettled, { once: true });
      } else {
        // Запасной путь для браузеров без `scrollend` (Safari до недавних
        // версий) — тот же таймаут, что в макете (380ms), достаточный для
        // завершения smooth-скролла на разумную дистанцию.
        window.setTimeout(onSettled, 380);
      }
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    // PDP-09/мобильный интерактив (15.09.2026): драг-хендл шторки —
    // потянуть за полоску вниз закрывает лист. Разметка узла
    // (`.amore-pdp-details__grab`) и `touch-action: none`/`cursor: grab`
    // в CSS существовали с прошлого захода (см. amore-pdp.css) как задел
    // без реализации — сам жест отсутствовал в теме целиком (явно
    // зафиксировано комментарием в CSS). Порог закрытия 70px — то же
    // число, что в одобренном владельцем макете
    // (maket-pdp-mobile-interaktiv-2026-09-15, `dragDelta > 70`).
    // Pointer Events (не отдельно touch/mouse) покрывают тач и мышь одним
    // API. Класс `is-dragging` на шторке (amore-pdp.css) снимает
    // transition на время жеста — иначе перетаскивание «догоняет» палец
    // через анимацию вместо прямого следования.
    bindDetailsDrag() {
      const handle = this.querySelector('.amore-pdp-details__grab');
      if (!handle || typeof window.PointerEvent !== 'function') return;
      const DRAG_CLOSE_THRESHOLD = 70;
      let startY = null;
      let delta = 0;
      let activePointerId = null;

      const onMove = (event) => {
        if (startY === null || event.pointerId !== activePointerId) return;
        delta = Math.max(0, event.clientY - startY);
        this.drawer.style.transform = `translateY(${delta}px)`;
      };
      const endDrag = (event) => {
        if (startY === null || event.pointerId !== activePointerId) return;
        this.drawer.classList.remove('is-dragging');
        this.drawer.style.removeProperty('transform');
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', endDrag);
        window.removeEventListener('pointercancel', endDrag);
        const shouldClose = delta > DRAG_CLOSE_THRESHOLD;
        startY = null;
        delta = 0;
        activePointerId = null;
        if (shouldClose) this.closeDetails();
      };
      handle.addEventListener('pointerdown', (event) => {
        const isMobile = typeof window.matchMedia === 'function' &&
          window.matchMedia('(max-width: 899px)').matches;
        if (!isMobile) return;
        startY = event.clientY;
        delta = 0;
        activePointerId = event.pointerId;
        this.drawer.classList.add('is-dragging');
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', endDrag);
        window.addEventListener('pointercancel', endDrag);
      });
    }

    /* PDP-02 (09.09.2026): панель появляется закрытой (все разделы hidden),
       и открытие сразу раскрывает нужный раздел — заход из колонки покупки
       не требует отдельной прокрутки, раздел уже наверху. */
    openDetails(name) {
      this.drawer.hidden = false;
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('amore-pdp-layer-open');
      document.dispatchEvent(new CustomEvent('amore:layer'));
      this.activateDetailsTab(name);
      requestAnimationFrame(() => {
        this.drawer.classList.add('is-open');
        this.drawer.querySelector('[data-amore-pdp-details-close]')?.focus();
      });
    }

    closeDetails() {
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('amore-pdp-layer-open');
      document.dispatchEvent(new CustomEvent('amore:layer'));
      window.setTimeout(() => {
        if (this.drawer.classList.contains('is-open')) return;
        this.drawer.hidden = true;
        this.lastDrawerTrigger?.focus();
      }, 340);
    }

    // PDP-08 (15.09.2026): была bindDetailsAccordion() — тап по заголовку
    // мог закрыть его же повторным нажатием (openAccordionSection(null)).
    // В табах такого состояния нет: клик по вкладке всегда показывает её,
    // «закрыть всё» — не пункт меню, у Toteme (замер 15.09) его тоже нет.
    bindDetailsTabs() {
      this.querySelectorAll('[data-amore-pdp-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          this.activateDetailsTab(button.dataset.amorePdpToggle);
        });
      });
    }

    // PDP-08 (15.09.2026): была openAccordionSection() — переименована,
    // потому что сама функция не изменилась (по-прежнему «показать эту,
    // спрятать остальные»), меняется только то, ЧЕМ она вызывается снаружи.
    // aria-expanded → aria-selected и role="tab"/"tabpanel" в разметке
    // (снипет) — состояние читается скринридером как переключатель вкладок,
    // а не как раскрывашка. Сброс прокрутки при смене вкладки — по замеру
    // Toteme 15.09 (`.mob-Tabs_Tab`, клик переключает панель мгновенно и
    // возвращает её скролл на 0, не сохраняет прежнюю позицию предыдущей).
    activateDetailsTab(name) {
      this.querySelectorAll('[data-amore-pdp-toggle]').forEach((button) => {
        const isTarget = button.dataset.amorePdpToggle === name;
        button.setAttribute('aria-selected', String(isTarget));
        const content = this.querySelector(`#${button.getAttribute('aria-controls')}`);
        if (content) content.hidden = !isTarget;
      });
      const body = this.drawer?.querySelector('.amore-pdp-details__body');
      if (body) body.scrollTop = 0;
    }

    trapDrawerFocus(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.closeDetails();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = Array.from(this.drawer.querySelectorAll(FOCUSABLE)).filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* Переключатель сантиметров и дюймов вернулся решением владельца 21.08:
       в макете его не было, но большая часть выручки приходит из стран, где
       сантиметры не читают. Переключает ОДНОВРЕМЕННО три обмера, подписи
       единиц у них и числа на чертеже — всё через `updateMeasurementState`,
       второго пути пересчёта в коде нет. */
    bindMeasurements() {
      this.querySelectorAll('[data-amore-pdp-unit]').forEach((button) => {
        button.addEventListener('click', () => {
          this.unit = button.dataset.amorePdpUnit;
          this.querySelectorAll('[data-amore-pdp-unit]').forEach((unitButton) => {
            unitButton.setAttribute('aria-pressed', String(unitButton === button));
          });
          const selected = this.variantById(this.dataset.selectedVariantId);
          this.updateMeasurementState(selected ? selected.size : '');
        });
      });
      this.querySelectorAll('[data-amore-pdp-sheet-size]').forEach((button) => {
        // Недоступный размер не нажимается: у него стоит `disabled`, и
        // обработчик ему не нужен — нажатие всё равно не дойдёт.
        if (button.disabled) return;
        button.addEventListener('click', () => this.chooseSize(button.dataset.amorePdpSheetSize));
      });
      this.bindAllSizes();
      this.bindConversion();
    }

    bindAllSizes() {
      const button = this.querySelector('[data-amore-pdp-all-sizes]');
      const panel = this.querySelector('.amore-pdp-details__all');
      if (!button || !panel) return;
      button.addEventListener('click', () => {
        const open = panel.hidden;
        panel.hidden = !open;
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? 'Hide' : 'All sizes';
      });
    }

    chooseSize(size) {
      const input = Array.from(this.querySelectorAll('[data-amore-pdp-size-value]')).find(
        (candidate) => candidate.dataset.amorePdpSizeValue === size && !candidate.disabled
      );
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Клик по колонке выбирает размер. Подсветка колонки/строки под курсором
       (PDP-03, 09.09.2026) — чистый CSS (:hover, только указатель), клика не
       требует; здесь только выбор размера и клавиатурная активация ячеек. */
    bindConversion() {
      const table = this.querySelector('.amore-pdp-conversion');
      if (!table) return;

      const headers = Array.from(table.querySelectorAll('thead th[data-amore-pdp-conv-col]'));
      const activate = (cell) => {
        const header = headers[Number(cell.dataset.amorePdpConvCol)];
        if (header) this.chooseSize(header.textContent.trim());
      };

      table.addEventListener('click', (event) => {
        const cell = event.target.closest('[data-amore-pdp-conv-col]');
        if (cell) activate(cell);
      });

      // Клавиатура — прототип навешивает role="button" + Enter/Space на
      // каждую ячейку (:3828-3830).
      table.querySelectorAll('[data-amore-pdp-conv-col]').forEach((cell) => {
        cell.setAttribute('role', 'button');
        cell.setAttribute('tabindex', '0');
        cell.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            activate(cell);
          }
        });
      });
    }

    /* Подпись переизмеряется при смене ширины: шторка на 899/900 меняет
       ширину скачком, и вариант подписи обязан меняться вместе с ней. */
    bindDiagramResize() {
      const diagram = this.querySelector('[data-amore-mdg]');
      if (!diagram) return;
      const stage = diagram.querySelector('[data-amore-mdg-stage]');
      if (!stage) return;
      if ('ResizeObserver' in window) {
        new ResizeObserver(() => this.fitDiagramTags(diagram)).observe(stage);
      } else {
        window.addEventListener('resize', () => this.fitDiagramTags(diagram));
      }
      this.fitDiagramTags(diagram);
    }

    /* Сантиметры показываются как есть, включая дробные (12.5). Дюймы —
       до одного знака: у обмеров изделия точность больше десятой дюйма
       не имеет смысла и даёт «5.118».
       size_rows намеренно допускает вилку вместо одного числа (регулируемая
       талия и т.п.), формат "A-B" — Number() на строке с дефисом даёт NaN,
       поэтому каждая граница переводится по отдельности. */
    convertMeasure(raw) {
      if (raw === '' || raw === undefined || raw === null) return null;
      const bounds = String(raw).split('-').map((part) => part.trim());
      const converted = bounds.map((bound) => {
        const number = Number(bound);
        if (bound === '' || !isFinite(number)) return null;
        return this.unit === 'cm' ? number : Math.round((number / 2.54) * 10) / 10;
      });
      if (converted.some((value) => value === null)) return null;
      return converted.join('-');
    }

    renderDiagramNumbers(size) {
      const diagram = this.querySelector('[data-amore-mdg]');
      if (!diagram) return;
      const button = size
        ? this.querySelector(`[data-amore-pdp-sheet-size="${CSS.escape(size)}"]`)
        : null;
      diagram.querySelectorAll('[data-amore-mdg-num]').forEach((node) => {
        const key = node.dataset.amoreMdgNum;
        const value = this.convertMeasure(button ? button.dataset['amorePdpCm' + key.toUpperCase()] : '');
        node.textContent = value === null ? '' : `${value} ${this.unit}`;
      });
      this.fitDiagramTags(diagram);
    }

    /* Формат подписи выбирается ЗАМЕРОМ, а не порогом ширины экрана: подписи
       сначала ставятся полными, затем проверяется, не вышла ли хоть одна за
       края чертежа и не пересеклась ли с соседней. Если да — слово опускается
       у всех трёх сразу, иначе подписи разной длины читаются как разнобой.
       Длина подписи зависит от метаполя, поэтому угадать порог нельзя. */
    fitDiagramTags(diagram) {
      const stage = diagram.querySelector('[data-amore-mdg-stage]');
      if (!stage) return;
      const tags = Array.from(diagram.querySelectorAll('.amore-mdg__tag'));
      if (!tags.length) return;
      diagram.classList.remove('is-short');
      if (!stage.getBoundingClientRect().width) return;
      const stageRect = stage.getBoundingClientRect();
      const rects = tags.map((tag) => tag.getBoundingClientRect());
      const slack = 1;
      const outside = rects.some((rect) =>
        rect.left < stageRect.left - slack || rect.right > stageRect.right + slack);
      let crossing = false;
      for (let i = 0; i < rects.length && !crossing; i += 1) {
        for (let j = i + 1; j < rects.length; j += 1) {
          const a = rects[i];
          const b = rects[j];
          if (a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom) {
            crossing = true;
            break;
          }
        }
      }
      if (outside || crossing) diagram.classList.add('is-short');
    }

    /* Единственный источник обмеров — сами кнопки размеров: атрибуты
       `data-amore-pdp-cm-a/-b/-c` на них питают и блок трёх обмеров, и числа
       на чертеже. Своей копии значений ни у блока, ни у чертежа нет, поэтому
       разойтись между собой они не могут.
       Строка «The same size elsewhere» и залитая колонка таблицы берутся из
       самой таблицы — второй копии ряда перевода в разметке тоже нет. */
    updateMeasurementState(size) {
      let source = null;
      this.querySelectorAll('[data-amore-pdp-sheet-size]').forEach((button) => {
        const match = button.dataset.amorePdpSheetSize === size;
        button.setAttribute('aria-pressed', String(match));
        if (match) source = button;
      });

      this.querySelectorAll('[data-amore-pdp-meas-num]').forEach((node) => {
        const key = node.dataset.amorePdpMeasNum;
        const value = this.convertMeasure(source ? source.dataset['amorePdpCm' + key.toUpperCase()] : '');
        node.textContent = value === null ? '' : String(value);
      });
      this.querySelectorAll('[data-amore-pdp-meas-unit]').forEach((node) => {
        node.textContent = this.unit;
      });

      const table = this.querySelector('.amore-pdp-conversion');
      if (table) {
        const headers = Array.from(table.querySelectorAll('thead th[data-amore-pdp-conv-col]'));
        const index = headers.findIndex((header) => header.textContent.trim() === size);
        headers.forEach((header, position) => {
          header.classList.toggle('is-selected', position === index);
        });
        // Первый `<col>` принадлежит колонке подписей, поэтому смещение на 1.
        Array.from(table.querySelectorAll('colgroup col')).forEach((col, position) => {
          col.classList.toggle('is-selected', index >= 0 && position === index + 1);
        });
        const bodyRows = Array.from(table.querySelectorAll('tbody tr'));
        // PDP-03: контур выбранной колонки рисуется по ячейкам (border на
        // <col> не участвует в раскладке при border-collapse: separate),
        // поэтому тот же is-selected нужен и на <td> — тем же паттерном,
        // что уже стоял на заголовках выше.
        bodyRows.forEach((row) => {
          Array.from(row.querySelectorAll('td[data-amore-pdp-conv-col]')).forEach((cell, position) => {
            cell.classList.toggle('is-selected', position === index);
          });
        });
        this.querySelectorAll('[data-amore-pdp-conv-sys]').forEach((node) => {
          const row = bodyRows[Number(node.dataset.amorePdpConvSys)];
          const cell = row ? row.querySelectorAll('td')[index] : null;
          node.textContent = index >= 0 && cell ? cell.textContent.trim() : '';
        });
      }

      this.renderDiagramNumbers(size);
    }
  }

  if (!customElements.get('amore-product')) customElements.define('amore-product', AmoreProduct);
})();
